import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import Switch from '@mui/material/Switch';
import useDebounce from 'hooks/useDebounce';
import { checkHasCompanyFeature } from 'helper/commonFunctions';
import { AUDITION_REAPPLY } from 'helper/constants';
import AssessmentSettingsEvents from 'events/AssessmentSettingsEvents';
import ReapplyComponent from 'components/assessments_pages/asessment_settings_components/ReapplyComponent';
import { observer } from 'mobx-react-lite';
import Button from '@mui/material/Button';
import EditPanelSection from '../EditPanelSection';

const styles = {
    wrapper: {
        paddingBottom: 10,
        '& h5': {
            marginBottom: 10
        }
    },
    timerUnitsSelect: {
        width: 100,
        marginLeft: 8,
        marginRight: 6,
        padding: 0
    },
    timerSelectMenu: {
        padding: '6px 10px'
    },
    selectIconClassName: {
        marginTop: 1,
        marginRight: 0
    },
    upgradeText: {
        color: '#7F8084'
    }
};

const TimeframeSettings = observer(({
    classes, settings,
    changeAssessmentSettings, company, audition
}) => {
    const { name, uuid } = audition;
    const { reapplyTimeFrame, reapply } = settings;
    const canSetReinviteTimeframe = checkHasCompanyFeature(company, AUDITION_REAPPLY);

    const [daysValue, setDaysValue] = useState(reapplyTimeFrame || 180);
    const [settingEnabled, setSettingsEnabled] = useState(reapply || false);

    useDebounce(daysValue, 300, () => handleChangeTimer(daysValue));

    const handleSwitch = (e) => {
        const { checked } = e.target;
        setSettingsEnabled(checked);
        changeAssessmentSettings({ reapply: checked })
            .then(() => {
                setSettingsEnabled(checked);
                AssessmentSettingsEvents.REAPPLY_ENABLED({
                    enabled: checked,
                    ttName: name,
                    ttUUID: uuid
                });
            });
    };

    const handleChangeTimer = async (val) => {
        changeAssessmentSettings({ reapplyTimeFrame: val });
    };

    return (
        <EditPanelSection
            className={classes.wrapper}
            header={(
                 <>
                    Set Reinvite Timeframe
                     <Switch
                         checked={settingEnabled}
                         onChange={handleSwitch}
                         disabled={!canSetReinviteTimeframe}
                     />
                </>
            )}
        >

            <div className="u-dsp--f u-fdir--column">
                <ReapplyComponent
                    enabled={canSetReinviteTimeframe && settingEnabled}
                    initValue={daysValue}
                    onChange={setDaysValue}
                    hideTitle
                >
                    <p className="u-txt--normal u-mrg--tx3">
                        If the set time has passed or the candidate’s status is Expired or More time requested,
                        they’ll be re-invited to restart the assessment from scratch.
                    </p>
                    {
                        !canSetReinviteTimeframe && (
                            <p className={classes.upgradeText}>
                                Want to enable reinvite?
                                <Button
                                    variant="text"
                                    color="primary"
                                    onClick={() => window.open('/subscriptions', '_blank')}
                                >
                                    Upgrade account now
                                </Button>
                            </p>
                        )
                    }
                </ReapplyComponent>
            </div>
        </EditPanelSection>
    );
});

export default withRouter(withStyles(styles)(TimeframeSettings));
